import React, { Fragment } from "react";
import Image from "react-bootstrap/Image";

const CurbSideMapWrapper = ({ localProps, state, ...props }) => {
  return (
    <Fragment>
      <div className="container-fluid">
        <div className="row">
          <div id="onboarding-scrollbar" className="col-12 p-0">
            <div className="row justify-content-between align-items-center py-4">
              <h5 className="f12-400 col-8">
                Drop a pin to your address Move the marker as required
              </h5>
              <div className="pl-0 col-4 d-flex align-items-center justify-content-end">
                <div
                  className="d-flex align-items-center AutoDetectBtn"
                  onClick={localProps.onAutoDetectHandler}
                >
                  <Image
                    src={require("../../../../../../../../assets/images/UserManagement/map-pin-red.svg")}
                    fluid
                    alt="Auto Detect"
                    title="Auto Detect Location"
                    className="location-detections-popup-map-search"
                  />
                  <p className="f12-500 text-red">Auto Detect Location</p>
                </div>
              </div>
            </div>
            {props.children}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CurbSideMapWrapper;
